import usePageTitle from "@/lib/usePageTitle";
import { DIRECTORS, SECRETARY } from "@/lib/content";

export default function Board() {
  usePageTitle("Board");
  const initials = (n) => n.split(" ").map(p => p[0]).slice(0, 2).join("");

  return (
    <div data-testid="board-page">
      <section className="py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
          <div className="overline mb-6">Governance</div>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[0.98] tracking-tight max-w-3xl">
            Board of <span className="italic">Directors.</span>
          </h1>
          <p className="mt-8 text-[#5C5A56] text-lg leading-relaxed max-w-2xl">
            GESL Spinners Limited is led by a board with deep manufacturing and textile experience,
            stewarding the company across product, operations and responsible growth.
          </p>
        </div>
      </section>

      <section className="pb-12">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {DIRECTORS.map((d, i) => (
              <article
                key={d.name}
                data-testid="board-member-card"
                className="editorial-card p-8 md:p-12 flex items-center gap-6"
              >
                <div className="w-20 h-20 bg-[#2E4A3D] text-[#F8F7F4] flex items-center justify-center font-serif-display text-2xl shrink-0">
                  {initials(d.name)}
                </div>
                <div>
                  <div className="overline text-[#C25934]">Director · {String(i + 1).padStart(2, "0")}</div>
                  <h3 className="font-serif-display text-2xl md:text-3xl mt-2">{d.name}</h3>
                  <div className="text-[#5C5A56] text-sm mt-1">{d.role}</div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* COMPANY SECRETARY */}
      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
          <div className="bg-[#1A1A1A] text-[#F8F7F4] p-10 md:p-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-3">
              <div className="overline text-[#C25934]">Company Secretary</div>
            </div>
            <div className="md:col-span-9">
              <h3 className="font-serif-display text-4xl md:text-5xl">{SECRETARY.name}</h3>
              <p className="text-[#D9D4CC] mt-3">{SECRETARY.role}, GESL Spinners Limited.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CIN */}
      <section className="pb-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
          <div className="font-mono-ed text-xs tracking-widest text-[#5C5A56] uppercase">
            Corporate Identity Number · U17299UP2022PLC170471
          </div>
        </div>
      </section>
    </div>
  );
}
